import services from '../enums/services.enum';

class Services {

    static hasEnabled(service) {

        // if the service doesn't exist or is disabled by developer, return false
        if (!services[service]) {
            return false;
        }

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('disable-services')) {
            //check if the service is in the list of disabled services. Return false if it is.
            return !searchParams.get('disable-services').split(',').includes(service);
        }
        return services[service] === true;
    }
};

export default Services;